const Challenge = ({ onClick }) => {
  return (
    <button
      className='relative rounded-xl bg-secondary col-span-2 aspect-video'
      onClick={onClick}
    >
      <div className='text-white font-bold text-xl'>Challenge</div>
    </button>
  );
};

export default Challenge;
